import { SkuRecord, fromJSON } from "common/records/Sku";
import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";

import { fetch, loaded, receive, reset } from "common/reducers/Utils";
import {
  CLEAR_SKU,
  FETCH_SKU,
  RECEIVE_SKU,
  SET_LOADED,
  UPDATE_FORM,
  UPDATE_VALUE,
  RESET_SKU,
} from "common/reducers/sku.actions";

export const SkuStateRecord = Record({
  byId: Map<number, SkuRecord>(),
  lastSavedById: Map<number, SkuRecord>(),
});

export const initialState = SkuStateRecord();
export type SkuState = typeof initialState;

const model = "skus";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case FETCH_SKU:
      return fetch(state, model, fromJSON({ id: action.payload.id }));

    case RECEIVE_SKU:
      return receive(state, model, fromJSON(action.payload.sku));

    case SET_LOADED:
      return loaded(state, model, action.payload.id);

    case UPDATE_FORM:
      const { rootPath, name, value } = action.payload.event;
      return state.setIn(rootPath.concat(name.split(".")), value);

    case CLEAR_SKU:
      return reset(state, model, action.payload.id);

    case UPDATE_VALUE:
      return state.setIn([model, "byId", action.payload.id, "value"], action.payload.newValue);

    case RESET_SKU:
      return reset(state, model, action.payload.skuId) as RootState;

    default:
      return state;
  }
};
